import {$getSelection, $isRangeSelection, LexicalEditor} from "lexical"
import {$setBlocksType} from "@lexical/selection"
import {$createHeadingNode, HeadingTagType} from "@lexical/rich-text"

// const debug = "lexicalChangeHeading"
const debug = false

export function lexicalChangeHeading(editor: LexicalEditor, value: any /*HeadingTagType | 'custom-paragraph'*/) {
    editor.update(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
            $setBlocksType(selection, () => $createHeadingNode(value))
        }
    })
}